import NotFoundIcon from "components/Icons/NotFoundIcon"
import {
  ImageCardContainer,
  ImagePreviewWrapper,
  ImagePreview,
  ImageMask,
} from "./styled"
import { useAppSelector } from "app/hooks"
import { useProcessImage } from "features/meal/hooks"
import { PreviewImageSize } from "features/meal/mealSlice.types"

const ScanFailedPhoto = ({
  imageSize = "normal",
}: {
  imageSize?: PreviewImageSize
}) => {
  const { imageUrl, displayImageType } = useProcessImage()
  const imageBase64Encoded = useAppSelector(
    (state) => state.meal.imageBase64Encoded,
  )

  const hasBase64PreviewImage =
    displayImageType === "base64" && !!imageBase64Encoded

  const hasUrlPreviewImage = displayImageType === "url" && !!imageUrl

  const userUploadedImageUrl = hasBase64PreviewImage
    ? imageBase64Encoded
    : hasUrlPreviewImage
    ? imageUrl
    : ""

  const wrapperHeight = imageSize === "normal" ? 375 : 277
  const imageHeight = imageSize === "normal" ? 327 : 228

  return (
    <ImageCardContainer $height={wrapperHeight}>
      <ImagePreviewWrapper $height={imageHeight}>
        <ImagePreview src={userUploadedImageUrl} alt="Uploaded meal" />
        <ImageMask>
          <NotFoundIcon />
        </ImageMask>
      </ImagePreviewWrapper>
    </ImageCardContainer>
  )
}

export default ScanFailedPhoto
